module.exports = __webpack_public_path__ + "img/sec10mob.b390f1d2.png";